import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import { Box } from "theme-ui"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useBreakpointIndex } from "@theme-ui/match-media"
import RecentPost from "components/lists/recent-post-resources"

// markup
const IndexPage = ({ location, data }) => {
    const breakpoint = useBreakpointIndex()
    const { pageData, posts } = data
    const modifiedData = { pageData: { ...pageData, ...data.category } }
    const customJsx = (
        <>
            <Box>
                <GatsbyImage
                    image={getImage(pageData.image)}
                    alt={pageData.title}
                />
                <div
                    dangerouslySetInnerHTML={{ __html: pageData.Description }}
                ></div>
            </Box>
            <RecentPost posts={posts} />
        </>
    )

    const arrData = {
        location,
        data: modifiedData,
        customElement: customJsx,
        parentLink: "resources",
        // breadcrums // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query ResourcesPostQuery($slug: String!) {
        pageData: strapiArticle(
            category: { slug: { eq: "resources" } }
            Post_Type: { eq: "Blog_Post" }
            slug: { eq: $slug }
        ) {
            title
            Description
            published_date
            image {
                childImageSharp {
                    gatsbyImageData(
                        placeholder: DOMINANT_COLOR
                        width: 900
                        height: 300
                    )
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
        }
        category: strapiPage(
            slug: { eq: "edn-resources" }
            company: { shortname: { eq: "EDN" } }
        ) {
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
                publicURL
            }
        }
        posts: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
            limit: 4
        ) {
            edges {
                node {
                    slug
                    title
                    published_date
                }
            }
        }
    }
`
